import { StatusModal } from '@cian/frontend-e2e-deal-component';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { closeSubmittedAnketaModal } from '../../redux';
import {
  selectFormDefaults,
  selectIsSubmittedAnketaModalOpen,
  selectSubmittedAnketaApplication,
  selectSubmittedAnketaModalListNumber,
  selectSubmittedAnketaModalOffer,
} from '../../selectors/calculator';
import { formatCallSlotTitle, mapApplicationToSummaryCard } from '../../utils';
import { getUserInput } from '../../utils/tracking/getUserInput';
import { useTracking } from '../../utils/tracking/useTracking';

import { buildSubmittedAnketaModalSubtitle, SUBMITTED_ANKETA_MODAL_WARNING } from './constants';

export const SubmittedAnketaModalContainer: React.FC = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector(selectIsSubmittedAnketaModalOpen);
  const application = useSelector(selectSubmittedAnketaApplication);
  const offer = useSelector(selectSubmittedAnketaModalOffer);
  const listNumber = useSelector(selectSubmittedAnketaModalListNumber);
  const formState = useSelector(selectFormDefaults);
  const { trackShowSubmittedAnketaModal } = useTracking();

  const userInput = getUserInput(formState);

  useEffect(() => {
    if (isOpen) {
      trackShowSubmittedAnketaModal({ offer, userInput, listNumber });
    }
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  const handleClose = () => {
    dispatch(closeSubmittedAnketaModal());
  };

  if (!application) {
    return null;
  }

  const { callSlot, contact, offers, searchParams } = application;

  return (
    <StatusModal
      open={isOpen}
      onClose={handleClose}
      title={formatCallSlotTitle({ callSlot })}
      subtitle={buildSubmittedAnketaModalSubtitle(contact?.phone ?? null)}
      creditSummary={mapApplicationToSummaryCard({ offers, searchParams })}
      /* Пропс требует три строки, а бэк отдаёт поля контакта по отдельности необязательными:
         отсутствующее прячем пустой строкой, ради этого модалку не отменяем */
      clientContacts={{
        name: contact?.fullName ?? '',
        phone: contact?.phone ?? '',
        email: contact?.email ?? '',
      }}
      warning={SUBMITTED_ANKETA_MODAL_WARNING}
    />
  );
};

SubmittedAnketaModalContainer.displayName = 'SubmittedAnketaModalContainer';
